<script>
    export default {
        render (createElement) {
            return createElement('div', {
                class: [
                    'table-row',
                    'bg-grey-lightest',
                    'text-grey-darker',
                    'text-sm',
                    'font-semibold',
                    'tracking-wide',
                    'leading-none',
                    'uppercase'
                ].join(' ')
            }, this.$slots.default)
        }
    }
</script>
